import { USER_CONSTS as UC } from '../consts'
import services from '@/services/ascentiaServiceIndex'
import stores from '..'
import { role as roleEnum } from '@/utilities/userRoles'
import { permission as permissionEnum } from '@/utilities/userPermissions'
import { AIRLINE_TEXT_FIELD } from '@/utilities/appConsts'

const state = {
  termsLoaded: false,
  termsAcceptance: {
    accepted: false,
  },
  termsAccepted: false,
  termsLastAccepted: null,
  profileLoaded: false,
  profile: null,
  roles: [],
  airlines: [],
  company: '',
  releaseNotes: null,
  newReleaseNotes: null,
  companyList: [],
  newCompany: {},
  userGuide: new Blob(),
  permissions: [],
}

const getters = {
  profileLoaded: state => state.profileLoaded,
  permissions: state => state.permissions,
  getProfile: state => state.profile,
  hasRole: state => roleName => {
    if (state.profile) {
      return state.roles.some(role => role.name === roleName)
    }
    return false
  },
  isFeatureInvestigator: state =>
    getters.hasRole(state)(roleEnum.featureInvestigator.name),
  isIssueInvestigator: state =>
    getters.hasRole(state)(roleEnum.issueInvestigator.name),
  isIssueUpdater: state => getters.hasRole(state)(roleEnum.issueUpdater.name),
  isIssueReader: state => getters.hasRole(state)(roleEnum.issueReader.name),
  isInternalUser: state =>
    state.profile ? state.profile.isCollinsInternal : false,
  isAdmin: state => getters.hasRole(state)(roleEnum.admin.name),
  isAirlineAdmin: state => getters.hasRole(state)(roleEnum.airlineAdmin.name),
  isAirlineUser: state => getters.hasRole(state)(roleEnum.airlineUser.name),
  isEngineer: state => getters.hasRole(state)(roleEnum.engineer.name),
  isUserManager: state => getters.hasRole(state)(roleEnum.userManager.name),
  isTester: state => getters.hasRole(state)(roleEnum.tester.name),
  isAcmfUser: state => getters.hasRole(state)(roleEnum.acmfUser.name),
  isExporter: state => getters.hasRole(state)(roleEnum.exporter.name),
  isPwcUser: state => getters.hasRole(state)(roleEnum.pwcUser.name),
  isAcmfAnalyticsAuthorized: state =>
    getters.hasRole(state)(roleEnum.acmfAnalyticsAuthorized.name),
  isAnalyticAdmin: state => getters.hasRole(state)(roleEnum.analyticAdmin.name),
  isDocumentManager: state =>
    getters.hasRole(state)(roleEnum.documentManager.name),
  isAirlineManager: state =>
    getters.hasRole(state)(roleEnum.airlineManager.name),
  isUserReader: state => getters.hasRole(state)(roleEnum.userReader.name),
  isAnserUser: state => getters.hasRole(state)(roleEnum.anserUser.name),
  homepagePermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.homepage.name) > -1
      )
    }
  },
  fleetPageOpenMaintenancePermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.fleetPageOpenMaintenance.name) > -1
      )
    }
  },
  fleetPageMyFleetPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.fleetPageMyFleet.name) > -1
      )
    }
  },
  fleetPageFaultMessagePermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.fleetPageFaultMessage.name) > -1
      )
    }
  },
  fleetPageHealthScorePermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.fleetPageHealthScore.name) > -1
      )
    }
  },
  flightDataAnalyticComparisonPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.flightDataAnalyticComparison.name) > -1
      )
    }
  },
  flightDataFlightComparisonPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.flightDataFlightComparison.name) > -1
      )
    }
  },
  flightDataAnalyticTrendsPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.flightDataAnalyticTrends.name) > -1
      )
    }
  },
  flightDataFlightTrendsPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.flightDataFlightTrends.name) > -1
      )
    }
  },
  flightDataAcmfTrendsPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.flightDataAcmfTrends.name) > -1
      )
    }
  },
  flightDataAttachPlotToMxRecPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.flightDataAttachPlotToMxRec.name) > -1
      )
    }
  },
  flightDataSavedPlotsPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.flightDataSavedPlots.name) > -1
      )
    }
  },
  maintenanceGridPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.maintenanceGrid.name) > -1
      )
    }
  },
  maintenanceExportTableGridPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.maintenanceExportTableGrid.name) > -1
      )
    }
  },
  maintenanceExportTableDetailedPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.maintenanceExportTableDetailed.name) > -1
      )
    }
  },
  maintenanceManualMxRecPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.maintenanceManualMxRec.name) > -1
      )
    }
  },
  maintenanceRemovalsTimelinePermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.maintenanceRemovalsTimeline.name) > -1
      )
    }
  },
  reportsReportsApuPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.reportsReportsApu.name) > -1
      )
    }
  },
  reportsExportPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.reportsExport.name) > -1
      )
    }
  },
  subscriptionAcmfAnalyticsPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.subscriptionAcmfAnalytics.name) > -1
      )
    }
  },
  subscriptionAcmfReportsPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.subscriptionAcmfReports.name) > -1
      )
    }
  },
  subscriptionMaintenancePermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.subscriptionMaintenance.name) > -1
      )
    }
  },
  customAlertsFullFlightSimplePermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.customAlertsFullFlightSimple.name) > -1
      )
    }
  },
  customAlertsFullFlightAdvancedPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.customAlertsFullFlightAdvanced.name) > -1
      )
    }
  },
  customAlertsAcmfSimplePermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.customAlertsAcmfSimple.name) > -1
      )
    }
  },
  customAlertsAcmfAdvancedPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.customAlertsAcmfAdvanced.name) > -1
      )
    }
  },
  customAlertsDplfAdvancedPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.customAlertsDplfAdvanced.name) > -1
      )
    }
  },
  derivedParametersFullFlightPermission(state) {
    if (state.profile) {
      return (
        state.permissions
          .map(p => p.name)
          .indexOf(permissionEnum.derivedParametersFullFlight.name) > -1
      )
    }
  },
  adminPermission(state) {
    if (state.profile) {
      return (
        state.permissions.map(p => p.name).indexOf(permissionEnum.admin.name) >
        -1
      )
    }
  },
  mappedUserAirlines(state) {
    if (state.airlines) {
      return state.airlines
        .filter(item => item.icaoCode !== null)
        .map(item => {
          return {
            airlineId: item.id,
            airlineName: item.name,
            icaoCode: item.icaoCode,
            text: item[AIRLINE_TEXT_FIELD],
            value: item.id,
            search: `${item[AIRLINE_TEXT_FIELD]}${item.icaoCode}`,
            masterModelsWithPHMAgreements:
              item.masterModelsWithPHMAgreements || [],
            phmAgreementTypes: item.phmAgreementTypes || [],
          }
        })
    }
    return state.airlines
  },
  mappedUserAirlinesWithPhmAgreements(state) {
    if (state.airlines) {
      return state.airlines
        .filter(item => item.hasPhmAgreements)
        .filter(item => item.icaoCode !== null)
        .map(item => {
          return {
            airlineId: item.id,
            airlineName: item.name,
            icaoCode: item.icaoCode,
            text: item[AIRLINE_TEXT_FIELD],
            value: item.id,
            search: `${item[AIRLINE_TEXT_FIELD]}${item.icaoCode}`,
          }
        })
    }
    return state.airlines
  },
  mappedUserAirlinesWithMasterModels(state, getters, rootState, rootGetters) {
    const masterModelsData = rootGetters['lookups/mappedUserMasterModels']
    if (state.airlines.length > 0 && masterModelsData.length > 0) {
      const masterModelsWithPHMAgreements = state.profile.airlines.filter(
        x => x.masterModelsWithPHMAgreements,
      )
      const items = masterModelsWithPHMAgreements
        .map(item => {
          return {
            airlineId: item.id,
            text: item.name,
            value: item.id,
          }
        })
        .map(item => {
          const currentAirline = masterModelsWithPHMAgreements.find(
            al => al.id === item.airlineId,
          )
          const mms = masterModelsData
            .sort((a, b) =>
              a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
            )
            .filter(
              mm =>
                mm.airlineId === item.airlineId &&
                currentAirline.masterModelsWithPHMAgreements.includes(
                  mm.masterModelId,
                ),
            )
          return {
            ...item,
            items: mms,
          }
        })

      return items.sort((a, b) =>
        a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
      )
    }

    return []
  },
}

const actions = {
  async [UC.GET_TANDC_DATA]({ commit }) {
    const response = await services.user.getData('termsAcceptance', null, true)
    commit(UC.UPDATE_TANDC_STATUS, response.data)
  },
  async [UC.SET_TANDC_DATA]({ dispatch }) {
    await services.user.saveData('termsAcceptance')
    await dispatch(UC.GET_USER_PROFILE)
  },
  async [UC.GET_USER_PROFILE]({ commit }) {
    const response = await services.user.getData('profile', null, false)
    const responsePhmAirlines = await services.user.getData('phmAirlines')

    const userData = {
      ...response.data,
      phmAirlines: responsePhmAirlines.data,
    }
    if (!response || !response.data || !response.data.identityId) {
      stores.commit('updateApiDown', true)
    } else {
      commit(UC.UPDATE_USER_PROFILE, userData)
    }
  },
  async [UC.SET_GEOIP_ACCEPTANCE]() {
    await services.user.saveData('geoIP')
  },
  async [UC.SET_USER_FEEDBACK](context, feedbackFormData) {
    const UserFeedbackDto = {
      Message: feedbackFormData,
      FeedbackAddress: context.rootState.route.fullPath,
      VueBuildVersion: process.env.VERSION,
    }
    await services.user.saveData('userFeedback', UserFeedbackDto)
  },
  async [UC.GET_RELEASE_NOTES]({ commit }) {
    const response = await services.user.getData('releaseNotes')
    const data = response.data
    commit(UC.UPDATE_RELEASE_NOTES, data)
  },
  async [UC.GET_COMPANY_LIST]({ commit }) {
    const response = await services.user.getData('company', null, true)
    const data = response.data
    commit(UC.UPDATE_COMPANY_LIST, data)
  },
  async [UC.SET_COMPANY_LIST]({ commit, dispatch }, company) {
    const response = await services.user.saveData('company', company, true)
    const data = response.data
    commit(UC.UPDATE_NEW_COMPANY, data)
    await dispatch(UC.GET_COMPANY_LIST)
  },
  async [UC.GET_USER_HELP_GUIDE]({ commit }, airlineUser) {
    try {
      const response = await services.blobTransfer.getData(
        'pdf',
        airlineUser,
        true,
      )
      if (response.data) {
        commit(UC.UPDATE_USER_HELP_GUIDE, response.data)
      }
    } catch (error) {
      console.log(`${UC.GET_USER_HELP_GUIDE} error: ${error}`)
    }
  },
  [UC.SET_USER_AIRLINES]({ commit }, newAirline) {
    commit(UC.UPDATE_USER_AIRLINES, newAirline)
  },
}

const mutations = {
  [UC.UPDATE_TANDC_STATUS]: (state, data) => {
    if (data === '') {
      state.termsAccepted = false
      state.termsLastAccepted = null
    } else {
      state.termsAccepted = data.accepted
      state.termsLastAccepted = data.lastAcceptedOn
    }
    state.termsAcceptance = data
    state.termsLoaded = true
  },
  [UC.UPDATE_USER_PROFILE]: (state, data) => {
    state.profile = data
    state.roles = data.roles
    state.permissions = data.permissions
    state.airlines = data.airlines.map(airline => {
      const [phmAirline] = data.phmAirlines.filter(
        phmAirline => phmAirline.id === airline.id,
      )
      return {
        ...airline,
        hasPhmAgreements:
          phmAirline.phmAgreementTypes &&
          phmAirline.phmAgreementTypes.length > 0,
        masterModelsWithPHMAgreements: phmAirline.masterModelsWithPHMAgreements,
        phmAgreementTypes: phmAirline.phmAgreementTypes,
      }
    })

    state.company = data.company
    if (data.releaseNotes) {
      state.newReleaseNotes = data.releaseNotes
    }
    state.profileLoaded = true
  },
  [UC.UPDATE_USER_AIRLINES]: (state, data) => {
    const newAirlineObj = data
    newAirlineObj.hasPhmAgreements = false // No PHM Agreement when airline is created
    state.airlines = [...state.airlines, newAirlineObj]
  },
  [UC.UPDATE_RELEASE_NOTES]: (state, data) => {
    state.releaseNotes = data
  },
  [UC.UPDATE_COMPANY_LIST]: (state, data) => (state.companyList = data),
  [UC.UPDATE_NEW_COMPANY]: (state, data) => (state.newCompany = data),
  [UC.UPDATE_USER_HELP_GUIDE]: (state, data) => (state.userGuide = data),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
